(function() { window.GUID_3a68aae8_dd77_4071_ba5c_395c0f12b458 = { getGuid: function() { return "3a68aae8-dd77-4071-ba5c-395c0f12b458"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let OpponentsFiltersPreset;
        (function (OpponentsFiltersPreset) {
            OpponentsFiltersPreset[OpponentsFiltersPreset["MyDivisions"] = 0] = "MyDivisions";
            OpponentsFiltersPreset[OpponentsFiltersPreset["MyFriendsAndFavorites"] = 1] = "MyFriendsAndFavorites";
            OpponentsFiltersPreset[OpponentsFiltersPreset["SparesForDivisions"] = 2] = "SparesForDivisions";
            OpponentsFiltersPreset[OpponentsFiltersPreset["Custom"] = 3] = "Custom";
        })(OpponentsFiltersPreset = Enumeration.OpponentsFiltersPreset || (Enumeration.OpponentsFiltersPreset = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=OpponentsFiltersPreset.pre.js.map
